/* Boboné care page — material tabs: show one material card at a time. */
(function () {
  function init(root) {
    if (root.dataset.careWired) { return; }
    root.dataset.careWired = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-care-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-care-panel]'));

    function select(idx) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-care-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-care-panel') !== idx;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-care-tab'));
        // Reflect the open material in the URL so it can be shared/refreshed.
        var slug = tab.getAttribute('data-care-slug');
        if (slug && history.replaceState) {
          history.replaceState(null, '', '#' + slug);
        }
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if (next < 0) { next = tabs.length - 1; }
        if (next >= tabs.length) { next = 0; }
        tabs[next].focus();
        select(tabs[next].getAttribute('data-care-tab'));
      });
    });

    // Deep link: /pages/cuidado-de-prendas#lino opens the Lino card directly.
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash) {
      var target = tabs.filter(function (t) { return t.getAttribute('data-care-slug') === hash; })[0];
      if (target) {
        // Open the right material tab but leave the page at the top — the hash
        // must not make the browser jump/scroll to the tabs.
        select(target.getAttribute('data-care-tab'));
      }
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-care-tabs]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
